import { toBucketAssets } from '../utils/assets';

export const AVAILABLE_COUNTRIES = [
  {
    label: 'Argentina',
    labelShort: 'Arg',
    value: 'ARG',
    urlImg: toBucketAssets('icons/flags/ARG.svg'),
    currency: 'ars',
  },
  {
    label: 'Colombia',
    labelShort: 'Col',
    value: 'COL',
    urlImg: toBucketAssets('icons/flags/COL.svg'),
    currency: 'cop',
  },
  {
    label: 'Costa Rica',
    labelShort: 'C. Rica',
    value: 'CRI',
    urlImg: toBucketAssets('icons/flags/CRI.svg'),
    currency: 'crc',
  },
  {
    label: 'El Salvador',
    labelShort: 'E. Sal',
    value: 'SLV',
    urlImg: toBucketAssets('icons/flags/SLV.svg'),
    currency: 'usd',
  },
  {
    label: 'Uruguay',
    labelShort: 'Uru',
    value: 'URY',
    urlImg: toBucketAssets('icons/flags/URY.png'),
    currency: 'uyu',
  },
  {
    label: 'Venezuela',
    labelShort: 'Ven',
    value: 'VEN',
    urlImg: toBucketAssets('icons/flags/VEN.png'),
    currency: 'ves',
  },
];
